import { FruitfulLogoIcon, Icon, View, XStack } from 'smoothie';

const HEADER_SIDE_WIDTH = 40;

export const NewMemberHeader = () => {
    return (
        <XStack
            width="100%"
            alignItems="center"
            justifyContent="space-between"
            paddingTop={24}
            paddingHorizontal={24}
            $sm={{ paddingHorizontal: 32 }}
        >
            <View width={HEADER_SIDE_WIDTH} />
            <Icon icon={FruitfulLogoIcon} size={34} color="$green900" />
            <View width={HEADER_SIDE_WIDTH} />
        </XStack>
    );
};
